export default "/* purgecss start ignore */\n\np {\n  color: black;\n}\n\n/* purgecss end ignore */";